const BLOCKED_COACHING_STATUSES = new Set([
  "BASELINE_ASSESSMENT_REQUIRED",
  "MORE_INFORMATION_REQUIRED",
  "UPSTREAM_RECALCULATION_REQUIRED",
]);

export function coachingDecisionBlocksPlanGeneration(decision, options = {}) {
  const status = decision?.coaching_status;
  if (options.allowProposedContextPreview && status === "MORE_INFORMATION_REQUIRED") {
    return false;
  }
  return BLOCKED_COACHING_STATUSES.has(status);
}

export function coachingDecisionPrerequisiteMessage(decision) {
  if (decision?.coaching_status === "MORE_INFORMATION_REQUIRED") {
    return "Complete your coaching setup before replacing your plan.";
  }
  const sections = decision?.explanation_sections || [];
  const changeSection = sections.find(
    (section) => section.key === "WHAT_COULD_CHANGE_THE_DECISION",
  );
  const facts = (changeSection?.facts || [])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
  if (facts.length > 0) {
    return facts.join(" ");
  }
  if (decision?.coaching_status === "BASELINE_ASSESSMENT_REQUIRED") {
    return (
      "Complete your training goal target and current baseline before "
      + "replacing your plan."
    );
  }
  return "More information is required before your training plan can be built.";
}
